import { Box, Typography } from "@mui/material";
import mobileIllustration from "./mobile_default.svg";

export default function MobileUnavailableScreen() {
  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: "#F7F7FA",
        backgroundImage:
          "url('https://quest-static-bucket.s3.ap-south-1.amazonaws.com/themes/default/background.png')",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "100dvh",
        overflow: "hidden",
        position: "relative",
        px: "30px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "transparent",
          inset: 0,
          position: "absolute",
          zIndex: 0,
        }}
      />

      <Box
        component="img"
        src={mobileIllustration}
        alt="Mobile screen unavailable illustration"
        sx={{
          height: "auto",
          maxWidth: "none",
          mx: "-30px",
          position: "relative",
          width: "calc(100% + 60px)",
          zIndex: 1,
        }}
      />

      <Typography
        sx={{
          color: "#444444",
          fontFamily: "Montserrat, sans-serif",
          fontSize: "24px",
          fontWeight: 600,
          lineHeight: 1.4,
          maxWidth: "90%",
          mt: 0,
          position: "relative",
          textAlign: "center",
          zIndex: 1,
        }}
      >
        Hey! This one needs a bigger screen
      </Typography>

      <Typography
        sx={{
          color: "#444444",
          fontFamily: "Montserrat, sans-serif",
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: 1.4,
          maxWidth: "97%",
          mx: "-30px",
          mt: "16px",
          opacity: 0.96,
          position: "relative",
          textAlign: "center",
          width: "calc(100% + 60px)",
          zIndex: 1,
        }}
      >
        For full functionality and a better experience, please access this app
        on a desktop device
      </Typography>
    </Box>
  );
}
